import { FilterDataOption } from "./Filter";
import { TimeOfDayOptions } from "./filterHelpers";

export const getWeekDayIndex = (weekdayName: string) => {
    const index = [
        "monday",
        "tuesday",
        "wednesday",
        "thursday",
        "friday",
        "saturday",
        "sunday",
    ].indexOf(weekdayName.toLowerCase());

    return index > -1 ? index + 1 : null;
};

export const dayOfWeekOptions: FilterDataOption[] = [
    { label: "Monday", value: "monday" },
    { label: "Tuesday", value: "tuesday" },
    { label: "Wednesday", value: "wednesday" },
    { label: "Thursday", value: "thursday" },
    { label: "Friday", value: "friday" },
    { label: "Saturday", value: "saturday" },
    { label: "Sunday", value: "sunday" },
];

export const timeOfDayOptions: FilterDataOption[] = [
    { label: "Morning", value: TimeOfDayOptions.morning },
    { label: "Afternoon", value: TimeOfDayOptions.afternoon },
    { label: "Evening", value: TimeOfDayOptions.evening },
];
